/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ScheduleRecommendationResourceScheduleRequest {
    getFixupPrototypeFunction() { return ScheduleRecommendationResourceScheduleRequest.fixupPrototype; }

    static newInstance(model: Partial<ScheduleRecommendationResourceScheduleRequest>): ScheduleRecommendationResourceScheduleRequest {
        let obj = Object.assign(new ScheduleRecommendationResourceScheduleRequest(), model);
        ScheduleRecommendationResourceScheduleRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ScheduleRecommendationResourceScheduleRequest>): ScheduleRecommendationResourceScheduleRequest {
        if (!model) return null;
        return ScheduleRecommendationResourceScheduleRequest.newInstance(<ScheduleRecommendationResourceScheduleRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ScheduleRecommendationResourceScheduleRequest) {
        if (!obj) return;

        models.ScheduleRecommendationResourceScheduleRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ScheduleRecommendationResourceScheduleRequest): boolean {
        Object.setPrototypeOf(obj, ScheduleRecommendationResourceScheduleRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.min_saving === undefined) {
            this.min_saving = 0;
        }
        if (this.max_saving === undefined) {
            this.max_saving = 0;
        }
    }

    /**
     * Service Account Ids
     */
    service_account_ids: Array<string>;

    /**
     * Schedule Finding Type
     */
    schedule_finding: models.ScheduleFinding;

    /**
     * Schedule Recommendation Statistical Method Name
     */
    statistical_method: models.ScheduleRecommendationStatisticalMethod;

    /**
     * Minimum Cost Savings Filter
     */
    min_saving: number;

    /**
     * Maximum Cost Savings Filter
     */
    max_saving: number;

    /**
     * Search resource_name and resource_type fields
     */
    search: string;

}
